import { createRoute } from '@tanstack/react-router';
import { format, subMonths } from 'date-fns';
import { labExpiredParentRoute } from 'pages/lab/labParentRoute';
import { zodOptionalDate, zodOptionalDateRange, zodOptionalIdArray } from 'routes/routeUtils';
import { z } from 'zod';

const baseLabExpiredProductsRequestsStatusSchema = z.enum([
  'ongoing',
  'awaiting_signing',
  'signed_by_pharmacy',
  'validated_by_lab',
  'refused_by_lab',
]);

export const baseLabExpiredProductsRequestsSearchSchema = z.object({
  query: z.string().optional(),
  groupIds: zodOptionalIdArray,
  salesRepIds: zodOptionalIdArray,
  regionalDirectorIds: zodOptionalIdArray,
  pharmacyIds: zodOptionalIdArray,
  status: z
    .tuple([baseLabExpiredProductsRequestsStatusSchema], baseLabExpiredProductsRequestsStatusSchema)
    .optional(),
  validatedAtRange: zodOptionalDateRange,
  createdAtRange: zodOptionalDateRange,
});

export type BaseLabExpiredProductsRequestsSearchType = z.infer<
  typeof baseLabExpiredProductsRequestsSearchSchema
>;

export const labExpiredProductsRequestsDashboardRoute = createRoute({
  getParentRoute: () => labExpiredParentRoute,
  path: '/dashboard',
  validateSearch: z.object({
    ...baseLabExpiredProductsRequestsSearchSchema.shape,
    createdAtRange: z
      .object({ from: zodOptionalDate, to: zodOptionalDate })
      .default({
        from: format(subMonths(Date.now(), 3), 'yyyy-MM-dd'),
      })
      .optional(),
  }),
}).lazy(() =>
  import(
    'pages/lab/ExpiredProductsRequests/LabExpiredProductsRequestsDashboardPage/LabExpiredProductsRequestsDashboardPage'
  ).then((d) => d.Route)
);
